import {useAppSelector} from '@/hooks/useRedux';
import {selectIsFeedFocused} from '@/store/feed';

export const useIsFeedFocused = () => {
  return useAppSelector(selectIsFeedFocused);
};
